export default "__VITE_ASSET__DxhM7vNU__"